import { useGetStacCollectionQuery } from 'src/shared/state/api-slices/stacCatalogueEngineSlice';
import { attributionOf, type CatalogueAttribution } from './catalogueAttribution';

/** The admin form writes the credit into the collection. A credit restated in this
 *  product can only disagree with that document. */
const useCatalogueAttribution = (collectionId: string): CatalogueAttribution | null => {
    // CAUTION: use `currentData`, not `data`. RTK keeps the result of the previous
    // argument while a new one loads. `data` credits one dataset for the shapes of another.
    const { currentData } = useGetStacCollectionQuery(collectionId);

    return attributionOf(currentData);
};

export default useCatalogueAttribution;
